import CardDemo from './CardDemo'

export default CardDemo
// eslint-disable-next-line import/export
export * from './CardDemo'
